import React from 'react'
import { FiMapPin } from "react-icons/fi";
import { GrPhone } from "react-icons/gr";
import { TfiEmail } from "react-icons/tfi";
import { PiFacebookLogoFill } from "react-icons/pi";
import { FaInstagram, FaLinkedin } from "react-icons/fa6";
import { ImLinkedin } from "react-icons/im";
import { FaTwitch } from "react-icons/fa6";

const AboutFoot = () => {
  return (
   <>
    <div className= 'w-[90vw] lg:w-[85vw]   mx-auto '>
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gao-x-2 lg:gap-x-[1vw] my-[50px] '>
        <div className='text-left mx-auto'>
           <p className='text-[22px] lg:text-34 font-bold font-urbanist '> 
            Contact Us
           </p>
            <p className='text-[14px] lg:text-[1vw] font-urbanist text-[#798196]' >Ready to find your perfect car? Contact us today to learn more about our selection and services. Whether you’re looking for a family vehicle, a luxury ride, or something in between, we’re here to help you every step of the way.</p>
          </div>
          <div className='text-left mx-auto '>
             <p className='text-[22px] lg:text-34 font-bold font-urbanist'>
                Follow
             </p>
             <div className="flex gap-[1vw] text-[#798196] ">
           <a href="http://www.facebook.com/profile.php?id=61551602116759" target="_blank" rel="noopener noreferrer" className="bg-[#ebebeb] cursor-pointer hover:bg-[#dcdcdc] rounded-lg p-1 lg:p-[0.2vw] hover:scale-110 duration-150">
                         <PiFacebookLogoFill />
                       </a>
                       <a href="https://www.instagram.com/luxfirstchoicecars" target="_blank" rel="noopener noreferrer" className="bg-[#ebebeb] cursor-pointer hover:bg-[#dcdcdc] rounded-lg p-1 lg:p-[0.2vw] hover:scale-110 duration-150">
                         <FaInstagram />
                       </a>
                       <a href="https://www.linkedin.com/company/lux-first-choice-cars" target="_blank" rel="noopener noreferrer" className="bg-[#ebebeb] cursor-pointer hover:bg-[#dcdcdc] rounded-lg p-1 lg:p-[0.2vw] hover:scale-110 duration-150">
                         <FaLinkedin />
                       </a>
            
          </div>
             <p className='text-[14px] lg:text-[1vw] font-urbanist  text-[#798196]'>
             At LUX First Choice Cars, we’re not just selling cars; we’re creating experiences and building relationships. Join our family today and discover the difference of choosing LUX First Choice Cars.
             </p>
          </div>
          <div className='text-left mx-auto '>
            <div className='text-[22px] lg:text-34 font-bold font-urbanist'>
            Get in touch
            </div>

            <div  className='flex  items-center gap-[1vw] '>
            <FiMapPin className='text-primary-red' />
            <p className='text-[22px] lg:text-[1vw] font-semibold font-urbanist'>Headquaters</p>
            <p className='text-[14px] lg:text-[1vw] font-urbanist'>Abaco</p>
            <p className='text-[14px] lg:text-[1vw] font-urbanist'>Bahmas</p>

            </div>


           <div className='flex  flex-col lg:flex-row gap-[1vw]'>
           <div>
                     <div className='flex lg:justify-center items-center gap-[0.6vw] pb-[1.5vh]'>
                     <GrPhone  className='text-primary-red' />
                     <p className='text-[14px] text-left lg:text-[1vw] font-semibold font-urbanist'>Calling Support</p>
                     </div>
                     <p  className='text-[14px] lg:text-[1vw] font-urbanist text-[#798196]'>
                     1242-825-9510

                     </p>
                     <p  className='text-[14px] lg:text-[1vw] font-urbanist text-[#798196]'>
                     1954-737-5889
                     </p>
            </div>
            <div>
                     <div className='flex lg:justify-center items-center gap-[0.6vw] pb-[1.5vh]'>
                     <TfiEmail className='text-primary-red' />
                     <p className='text-[14px] lg:text-[1vw] font-semibold font-urbanist'>Email Information</p>
                     </div>
                     <p className='text-[14px] lg:text-[1vw] font-urbanist text-[#798196]'>
                     customersupport@bidcaribbean.co


                     </p>
                     <p className='text-[14px] lg:text-[1vw] font-urbanist text-[#798196]'>
                     Info@luxfirstchoicecars.com
                     </p>
            </div>
           </div>
          </div>
        </div>
    </div>
   </>
  )
}

export default AboutFoot